import React from "react";
import {
  Button,
  Modal,
  Form,
  ModalBody,
  Card,
  Row,
  Col,
} from "react-bootstrap";
import _ from "lodash";
import DatePicker from "react-datepicker";
import { CurrentPermitActions } from "../../Actions";
import { useDispatch, useSelector } from "react-redux";
import CustomContentAlert from "../helper";
import t from "../../Actions/CurrentPermitActions/types";
import moment from "moment";

const EditCurrentPermit = ({ closeModal, permitData, modelOpen, status }) => {
  const [isFormValid, setIsFormValid] = React.useState(false);
  const [state, setState] = React.useState({
    email: "",
    lpn: "",
    lot: "",
    FirstName: "",
    LastName: "",
    country_code: "",
    phone: "",
    //  permit_start_date: "",
    permit_end_date: "",
    card_number: "",
    stall_id: "",
    country_code_list: [
      { text: "+1", value: "+1" },
      { text: "+91", value: "+91" },
      { text: "+44", value: "+44" },
      { text: "+61", value: "+61" },
    ],
    phone_options: [],
    deleted_phone_id: [],
  });

  const dispatch = useDispatch();
  const [validation1, setValidation1] = React.useState({
    isemail: false,
    isfirstName: false,
    islastName: false,
    isphone: false,
    disabledDate: true,
    iscardNumber: false,
  });
  const [validation, setValidation] = React.useState({
    email: "",
    FirstName: "",
    LastName: "",
    phone: "",
    userType: "",
    card_number: "",
  });

  const apiMessage = useSelector(
    (currentPermitState) => currentPermitState.CurrentPermitDetails.message
  );
  const UserProfileDetails = useSelector(
    (UserProfileDetails) => UserProfileDetails.UserProfileDetails
  );

  React.useEffect(() => {
    let timeout = null;
    if (apiMessage && apiMessage.isSuccess && apiMessage.message !== "") {
      timeout = setTimeout(() => {
        closeModal(false);
      }, 1000);
    }
    return () => {
      if (timeout !== null) clearTimeout(timeout);
    };
  }, [dispatch, apiMessage]);

  React.useEffect(() => {
    if (modelOpen) {
      dispatch({
        type: t.UPDATE_PERMIT_ERROR,
        payload: "",
      });
    }
  }, [modelOpen]);

  React.useEffect(() => {
    if (
      !validation1.isemail &&
      !validation1.isfirstName &&
      !validation1.islastName &&
      !validation1.isphone &&
      isMultiplePhoneValid()
    ) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  }, [validation1, state.phone_options]);

  React.useEffect(() => {
    if (permitData) {
      const {
        email,
        lot_name,
        country_code,
        phone,
        first_name,
        last_name,
        lpn,
        begin_time,
        expire_time,
        card_number,
        stall_id,
        phone_options,
      } = permitData;
      setState({
        ...state,
        email: email,
        stall_id: stall_id,
        lpn: lpn,
        lot: lot_name,
        FirstName: first_name,
        LastName: last_name,
        card_number: card_number,
        country_code: country_code,
        phone: phone,
        permit_start_date: begin_time,
        permit_end_date: expire_time,
        country_code_list: [
          { text: "+1", value: "+1" },
          { text: "+91", value: "+91" },
          { text: "+44", value: "+44" },
          { text: "+61", value: "+61" },
        ],
        phone_options: phone_options,
      });
      const expire_date = moment(expire_time).format("YYYY-MM-DD HH:mm:SS");
      const convertedExpireTime = moment
        .tz(expire_date, UserProfileDetails.timezone)
        .format();
      const currentDate = new Date().toLocaleString("en-US", {
        timeZone: UserProfileDetails.timezone,
      });
      const formatedCurrentTime = moment(currentDate).format(
        "YYYY-MM-DD HH:mm:SS"
      );
      const convertedCurrentTime = moment
        .tz(formatedCurrentTime, UserProfileDetails.timezone)
        .format();
      if (convertedExpireTime > convertedCurrentTime) {
        setState((prevState) => ({
          ...prevState,
          disabledDate: true,
        }));
      } else {
        setState((prevState) => ({
          ...prevState,
          disabledDate: false,
        }));
      }
    }
  }, [permitData]);

  const PhoneValidation = (phone) => {
    if ((phone && phone.length >= 11) || (phone && phone.length < 10)) {
      setIsFormValid(true);
      return "Please  enter valid Phone Number";
    } else if (!/^\d+$/.test(phone)) {
      return "Please  enter valid Phone Number";
    } else {
      setIsFormValid(false);
      return "";
    }
  };

  const isMultiplePhoneValid = () => {
    const validPhone = state.phone_options.map((options) => {
      if (
        options.phone.trim().length > 10 ||
        options.phone.trim().length < 10 ||
        options.phone.trim().length === 0
      ) {
        return !(
          options.phone.trim().length > 10 ||
          options.phone.trim().length < 10 ||
          options.phone.trim().length === 0
        );
      }
      return true;
    });
    console.log("validPhone:::", validPhone);
    return !validPhone.includes(false);
  };

  const permitUpdate = () => {
    const {
      email,
      country_code,
      phone,
      FirstName,
      LastName,
      permit_end_date,
      card_number,
      stall_id,
      phone_options,
      deleted_phone_id,
    } = state;
    const expire_date = moment(permit_end_date).format("YYYY-MM-DD HH:mm:SS");
    const convertedExpireTime = moment
      .tz(expire_date, UserProfileDetails.timezone)
      .format();
    const UTCET = moment.tz(convertedExpireTime, "UTC").format();
    const data = {
      email,
      country_code,
      phone,
      first_name: FirstName,
      last_name: LastName,
      expire_time: UTCET,
      card_number: card_number,
      stall_id: stall_id,
      old_data: permitData,
      status,
      phone_options,
      deleted_phone_id,
    };
    dispatch(CurrentPermitActions.updatePermit(permitData.id, data));
  };

  const handleAddPhoneOptions = () => {
    setState({
      ...state,
      phone_options: [
        ...state.phone_options,
        { country_code: "+1", phone: "" },
      ],
    });

    console.log("state.phone_options:::", state.phone_options);
  };

  const handlePhoneOptions = (index, value, type) => {
    console.log("index, value :::::", index, value, type);

    console.log("phone_options:::", state.phone_options);
    const { phone_options } = state;
    let phone_values;
    let country_code_values;

    setState({
      ...state,
      phone_options: state.phone_options.map((item, i) => {
        const obj = { ...item };
        if (i === index) {
          console.log("in mapppppppp");
          if (type === "phone_number_options") {
            phone_values = value
              .replace(/[^0-9.]/g, "")
              .replace(/(\..*)\./g, "$1");
            obj.phone = phone_values;
          }
          if (type === "country_code_options") {
            country_code_values = value;
            obj.country_code = country_code_values;
          }
        }
        return obj;
      }),
    });

    console.log("phone_options::::", phone_options);
  };

  const removePhoneOption = (index) => {
    const deleted_ID = state.phone_options[index];
    console.log(
      "index on remove::::",
      index,
      deleted_ID,
      state,
      state.deleted_phone_id
    );
    setState({
      ...state,
      phone_options: [...state.phone_options.filter((_x, i) => i !== index)],
      deleted_phone_id: [...state.deleted_phone_id, deleted_ID],
    });
  };

  const handleChange = React.useCallback((e) => {
    setState((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
    if (e.target.name === "country_code") {
      setState((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value.replace(/[a-zA-Z]/, ""),
      }));
    } else {
      setValidations(e);
    }
  }, []);

  const setValidations = React.useCallback(
    (e) => {
      if (!e.target.value) {
        setValidation((prevState) => ({
          ...prevState,
          [e.target.name]: e.target.name + " is required",
        }));
        setIsFormValid(false);
      } else {
        if (e.target.name === "LastName") {
          setValidation1((prevState) => ({
            ...prevState,
            islastName: false,
          }));
          setValidation((prevState) => ({
            ...prevState,
            [e.target.name]: "",
          }));
        } else if (e.target.name === "FirstName") {
          setValidation1((prevState) => ({
            ...prevState,
            isfirstName: false,
          }));
          setValidation((prevState) => ({
            ...prevState,
            [e.target.name]: "",
          }));
        } else if (e.target.name === "email") {
          const regex =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          setValidation((prevState) => ({
            ...prevState,
            [e.target.name]:
              e.target.value && !regex.test(e.target.value)
                ? "Please enter valid email"
                : "",
          }));
          if (e.target.value && regex.test(e.target.value)) {
            setValidation1((prevState) => ({
              ...prevState,
              isemail: false,
            }));
          } else {
            setValidation1((prevState) => ({
              ...prevState,
              isemail: true,
            }));
          }
        } else if (e.target.name === "phone") {
          const errMsg = PhoneValidation(e.target.value);
          setValidation((prevState) => ({
            ...prevState,
            [e.target.name]: errMsg,
          }));

          if (e.target.value && errMsg === "") {
            setValidation1((prevState) => ({
              ...prevState,
              isphone: false,
            }));
          } else {
            setValidation1((prevState) => ({
              ...prevState,
              isphone: true,
            }));
          }
        } else if (e.target.name === "card_number") {
          setValidation1((prevState) => ({
            ...prevState,
            iscardNumber: false,
          }));
          setValidation((prevState) => ({
            ...prevState,
            [e.target.name]: "",
          }));
        } else {
          setValidation((prevState) => ({
            ...prevState,
            [e.target.name]: "",
          }));
        }
      }
    },
    [validation]
  );

  const handleChangeEndingDates = (date) => {
    if (date) {
      date = moment(date).format("L");
    } else {
      date = moment().format("L");
    }
    setState((prevState) => ({
      ...prevState,
      permit_end_date: date,
      disabledDate: true,
    }));
  };

  return (
    <React.Fragment>
      <Modal
        id="ImportPermits"
        lg={"medium"}
        backdrop={"static"}
        show={true}
        onHide={closeModal}
        dialogClassName="modal-90w"
        fullscreen={"sm-down"}
      >
        <Card.Header className="d-flex justify-content-between bg-white align-items-center">
          <h4 className="m-0 font-weight-bold">
            <Card.Title className="m-0">Edit Permit</Card.Title>
          </h4>
          <Button
            title={"Deactivate"}
            type="button"
            onClick={closeModal}
            className="close-btn py-0"
            data-dismiss="modal"
          >
            <i className="nc-icon nc-simple-remove text-danger" />
          </Button>
        </Card.Header>

        <ModalBody>
          <Form.Group style={{ marginTop: -20 }}>
            <Row>
              <Col>
                <label>LPN</label>
                <Form.Control
                  placeholder="phone"
                  type="text"
                  name="phone"
                  value={state && state.lpn}
                  autoComplete="off"
                  disabled
                />
              </Col>
              <Col>
                <label>Lot</label>
                <Form.Control
                  placeholder="phone"
                  type="text"
                  name="phone"
                  value={state && state.lot}
                  autoComplete="off"
                  disabled
                />
              </Col>
            </Row>
            <label>
              Email
              <span className="asterisk">*</span>
            </label>
            <Form.Control
              placeholder="email"
              type="email"
              name="email"
              value={state && state.email}
              onChange={handleChange}
              autoComplete="off"
              required
            />
            <div className="help-block">
              {!_.isEmpty(validation) ? validation.email : ""}
            </div>

            <label>
              First Name
              <span className="asterisk">*</span>
            </label>
            <Form.Control
              placeholder="First Name"
              type="text"
              name="FirstName"
              value={state && state.FirstName}
              onChange={handleChange}
              autoComplete="off"
              required
            />
            <div className="help-block">
              {!_.isEmpty(validation) ? validation.FirstName : ""}
            </div>
            <label>
              Last Name
              <span className="asterisk">*</span>
            </label>
            <Form.Control
              placeholder="Last Name"
              type="text"
              name="LastName"
              value={state && state.LastName}
              onChange={handleChange}
              autoComplete="off"
              required
            />
            <div className="help-block">
              {!_.isEmpty(validation) ? validation.LastName : ""}
            </div>
            <label>Access Card/ Tag</label>
            <Form.Control
              placeholder="Card Number"
              type="text"
              name="card_number"
              value={state && state.card_number}
              onChange={handleChange}
              autoComplete="off"
              required
            />
            <div className="help-block">
              {!_.isEmpty(validation) ? validation.card_number : ""}
            </div>
            <label>Stall Id</label>
            <Form.Control
              placeholder="Stall id"
              type="text"
              name="stall_id"
              value={state && state.stall_id}
              onChange={handleChange}
              autoComplete="off"
            />

            <div className="custom-time d-flex align-items-center mb-1">
              <div className="d-flex align-items-center sm-flex-column">
                <div className="mb-3">
                  <label className="ml-2 mr-1">
                    End Date {state.disabledDate}
                    <span className="asterisk">*</span>
                  </label>
                  <DatePicker
                    placeholder="04/05/16"
                    minDate={new Date()}
                    selected={
                      state.permit_end_date
                        ? new Date(state.permit_end_date)
                        : new Date()
                    }
                    disabled={!state.disabledDate}
                    onChange={handleChangeEndingDates}
                  />

                  <div className="help-block">
                    {state.disabledDate === false
                      ? "This date is expired so you can not edit."
                      : ""}
                  </div>
                </div>
              </div>
            </div>
            <Row>
              <Col md="3">
                <label>Country Code</label>
                <Form.Control
                  as="select"
                  name="country_code"
                  onChange={handleChange}
                  value={state && state.country_code}
                  required
                >
                  {state.country_code_list ? (
                    <>
                      {state.country_code_list.map((item, index) => (
                        <option key={index} value={item.value}>
                          {item.text}
                        </option>
                      ))}
                    </>
                  ) : null}
                </Form.Control>
              </Col>
              <Col md="6">
                {" "}
                <label>
                  Phone
                  <span className="asterisk">*</span>
                </label>
                <Form.Control
                  placeholder="phone"
                  type="text"
                  name="phone"
                  value={state && state.phone}
                  onChange={handleChange}
                  autoComplete="off"
                  required
                />
                <div className="help-block">
                  {!_.isEmpty(validation) ? validation.phone : ""}
                </div>
              </Col>
              <Col md="3" className="mt-3">
                <Button
                  size="sm"
                  className="ml-3 mt-4"
                  disabled={
                    state.phone_options?.length > 9 ||
                    state?.phone?.trim()?.length === 0 ||
                    !isMultiplePhoneValid()
                  }
                  onClick={handleAddPhoneOptions}
                >
                  <i className="fas fa-plus-circle"></i>
                </Button>
              </Col>
            </Row>
            {state.phone_options &&
              typeof state.phone_options === "object" &&
              Array.isArray(state.phone_options) &&
              state.phone_options.map((option, index) => {
                return (
                  <Row key={option?.country_code} className="my-0">
                    <Col className="" md="3">
                      <Form.Group>
                        <Form.Control
                          as="select"
                          name="country_code_options"
                          onChange={(e) =>
                            handlePhoneOptions(
                              index,
                              e.target.value,
                              "country_code_options"
                            )
                          }
                          value={option?.country_code}
                          required
                        >
                          {state.country_code_list ? (
                            <>
                              {state.country_code_list.map((item) => (
                                <option key={item.text} value={item.value}>
                                  {item.text}
                                </option>
                              ))}
                            </>
                          ) : null}
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    <Col className="" md="6">
                      <Form.Group className="p-0 m-1">
                        {/* <Form.Label>Option {index + 1}</Form.Label> */}
                        {/* <span className="asterisk">*</span> */}
                        <Form.Control
                          placeholder="Phone Number"
                          type="text"
                          name="phone_number_options"
                          value={option?.phone}
                          // onBlur={(e) => e.target.value.trim() === "" && removeNoteOption(index)}
                          onChange={(e) =>
                            handlePhoneOptions(
                              index,
                              e.target.value,
                              "phone_number_options"
                            )
                          }
                          maxLength="10"
                          autoComplete="off"
                        />
                      </Form.Group>
                    </Col>
                    <Col md="2" className="mt-2">
                      <Button
                        size="sm"
                        className="ml-3"
                        onClick={() => removePhoneOption(index)}
                      >
                        <i className="fas fa-minus"></i>
                      </Button>
                    </Col>
                  </Row>
                );
              })}
          </Form.Group>
        </ModalBody>

        <Modal.Footer>
          <Button onClick={closeModal}>Cancel</Button>
          <Button
            variant="primary"
            disabled={!isFormValid}
            onClick={permitUpdate}
          >
            Update
          </Button>
        </Modal.Footer>
        {apiMessage && apiMessage.isSuccess && apiMessage.message !== "" && (
          <CustomContentAlert
            delay={4000}
            message={apiMessage.message}
            className={apiMessage.isSuccess ? "toast-success" : ""}
          />
        )}
      </Modal>
    </React.Fragment>
  );
};

export default EditCurrentPermit;
